
const AISummaryBox = ({
  aiSummary,
  setAiSummary,
  isGenerating,
  onGenerate,
}) => {
  return (
    <div className="space-y-6 px-4 py-2">
      <textarea
        value={aiSummary}
        onChange={(e) => setAiSummary(e.target.value)}
        placeholder="AI Summary will appear here..."
        className="w-full h-32 p-4 border border-gray-300 rounded-md mb-4 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <button
        type="button"
        onClick={onGenerate}
        disabled={isGenerating}
        className={`w-full flex justify-center items-center gap-2 border rounded-md px-4 py-2 text-lg font-medium
        ${
          isGenerating
            ? "bg-gray-200 text-gray-400 border-gray-200 cursor-not-allowed opacity-70"
            : "border-gray-300 text-gray-900 hover:bg-gray-100"
        }`}
      >
        {isGenerating ? (
          <>
            <svg
              className="w-5 h-5 animate-spin text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              />
            </svg>
            Generating AI Summary...
          </>
        ) : (
          <>
            <svg
              className="w-5 h-5 text-gray-900"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
              />
            </svg>
            Generate Summary with AI
          </>
        )}
      </button>
    </div>
  );
};

export default AISummaryBox;
